module.exports = __webpack_public_path__ + "static/파인애플-f872f4f3c8e896b72a0e0d948117e14c.jpg";